function normalizeGuestLimit (value) {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

function getGuestCapacityDescription ({ maxGuests = this.max_guests, maxAdults = this.max_adults, maxChildren = this.max_children } = {}) {
  const normalizedMaxGuests = normalizeGuestLimit(maxGuests)
  const normalizedMaxAdults = normalizeGuestLimit(maxAdults)
  const normalizedMaxChildren = normalizeGuestLimit(maxChildren)
  const guestGroups = []

  if (normalizedMaxAdults !== null) {
    guestGroups.push(`${normalizedMaxAdults} vuxna`)
  }
  if (normalizedMaxChildren !== null) {
    guestGroups.push(`${normalizedMaxChildren} barn`)
  }

  const displayedMaxGuests = normalizedMaxGuests ?? (
    normalizedMaxAdults !== null && normalizedMaxChildren !== null
      ? normalizedMaxAdults + normalizedMaxChildren
      : null
  )
  if (displayedMaxGuests !== null) {
    const totalLimit = `Max ${displayedMaxGuests} gäster`
    return guestGroups.length > 0
      ? `${totalLimit} varav ${guestGroups.join(' och ')}`
      : totalLimit
  }

  return guestGroups.length > 0
    ? `Obegränsat antal gäster totalt, men max ${guestGroups.join(' och ')}`
    : 'Obegränsat antal gäster'
}

function hasGuestCapacityLimit () {
  return normalizeGuestLimit(this.max_guests) !== null ||
    normalizeGuestLimit(this.max_adults) !== null ||
    normalizeGuestLimit(this.max_children) !== null
}

export default {
  getGuestCapacityDescription,
  hasGuestCapacityLimit
}
